/** @jsxImportSource @emotion/react */
import { Box } from '@mui/material'
import { PUBLIC_ASSETS_BASE_URL } from '@app/app-constants'
import { appLink } from '@app/config/appLink'
import { SidebarAtom } from '@app/state/layoutAtom'
import { AnimatePresence, motion } from 'framer-motion'
import { useAtomValue } from 'jotai'
import { useNavigate } from 'react-router-dom'
import { logoContainer, sidebarFullLogo, sidebarSimpleLogo } from './SidebarLogo.style'

export const SidebarLogo = () => {
  const navigate = useNavigate()
  const isOpen = useAtomValue(SidebarAtom)

  const UILogo = `${PUBLIC_ASSETS_BASE_URL}/images/shared/new_RexLogoSimple.svg`
  const UIFull = `${PUBLIC_ASSETS_BASE_URL}/images/shared/new_RexLogoFull.svg`

  const logoVariants = {
    initial: { opacity: 0, scale: 0.8, rotate: 0 },
    animate: { opacity: 1, scale: 1, rotate: 0 },
  }

  const containerVariants = {
    open: {
      transition: {
        staggerChildren: 0.05,
        delayChildren: 0.1,
      },
    },
    closed: {
      transition: {
        staggerChildren: 0.05,
        staggerDirection: -1,
      },
    },
  }

  return (
    <Box sx={{ width: '100%' }}>
      <motion.div
        css={logoContainer()}
        onClick={() => navigate(`${appLink.homepage.path}`)}
        role="button"
        aria-label="Go home"
        variants={containerVariants}
        animate={isOpen ? 'open' : 'closed'}
        transition={{ duration: 0, ease: 'easeOut' }}
      >
        <AnimatePresence mode="wait">
          {isOpen ? (
            <Box
              key="full"
              component="img"
              src={UIFull}
              alt="Urban Intelligence full logo"
              css={sidebarFullLogo}
            />
          ) : (
            <motion.img
              key="simple"
              src={UILogo}
              alt="Urban Intelligence simple logo"
              css={sidebarSimpleLogo}
              variants={logoVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={{ duration: 0.4, ease: 'easeOut' }}
            />
          )}
        </AnimatePresence>
      </motion.div>
    </Box>
  )
}
